import React from 'react'
import {Imagen} from 'asocomponents'
import {WEBURLEGALES} from "../../../helpers/frontend.js"

export default function NavBar() { 
  return (  
    <nav className="border-gray-200 shadow ml-10 mr-3 mt-2 mb-4">
    <div className="max-w-screen-xl flex flex-wrap items-center justify-center mx-auto p-4">
        <Imagen
          size="10"
          source={WEBURLEGALES + '/images/main-logo.svg'}
          alt="Asociart Logo"
        />
    </div>
  </nav>
  )
}
